import { ComposerMode } from '../types/index';
/**
 * Exactly one organizer per event. Returns `null` while calendar integration
 * is loading, or in EDIT when the space is not the API organizer (invitee
 * flags come from the API — don't overwrite).
 */
export function getEventOrganizer(_a) {
    var composerMode = _a.composerMode, isLoadingCalendarIntegration = _a.isLoadingCalendarIntegration, hasSelectedPersonalCalendar = _a.hasSelectedPersonalCalendar, spaceIsOrganizer = _a.spaceIsOrganizer;
    if (spaceIsOrganizer) {
        return 'space';
    }
    if (composerMode !== ComposerMode.CREATE) {
        return null;
    }
    if (isLoadingCalendarIntegration) {
        return null;
    }
    return hasSelectedPersonalCalendar ? 'user' : 'space';
}
